<script setup lang="ts">
/** Engagement Letter — SG Incorporation (Pre) */
import CddVarField from './cdd/CddVarField.vue';
import SgPreSigners from './SgPreSigners.vue';
import { SG_PRE_SIGNER_KEYS } from './cdd/sgPreSignersContext';
import './allotDoc.css';

/** 수수료 행별 통화 키 (서로 독립) */
const FEE_ROWS = [
  { fee: 'fee_incorporation_package', currency: 'currency_fee_incorporation_package', label: 'Company Incorporation (includes 1-year Corporate Secretarial & Registered Address)', section: null },
  { fee: 'fee_nominee_director', currency: 'currency_fee_nominee_director', label: 'Nominee Director Services', section: 'Optional Services' },
  { fee: 'fee_nominee_director_deposit', currency: 'currency_fee_nominee_director_deposit', label: 'Refundable Deposit for Nominee Directorship', section: null },
  { fee: 'fee_employment_pass', currency: 'currency_fee_employment_pass', label: 'Employment Pass Application Services', section: null },
  { fee: 'fee_corppass_opening', currency: 'currency_fee_corppass_opening', label: 'Opening Corppass', section: null },
  { fee: 'fee_bank_account_opening', currency: 'currency_fee_bank_account_opening', label: 'Opening Bank Account', section: null },
  { fee: 'fee_annual_secretarial', currency: 'currency_fee_annual_secretarial', label: 'Corporate Secretarial Service', section: 'Subsequent Year Services (Per Annum)' },
  { fee: 'fee_annual_registered_address', currency: 'currency_fee_annual_registered_address', label: 'Registered Address Service', section: null },
  { fee: 'fee_annual_nominee_director', currency: 'currency_fee_annual_nominee_director', label: 'Nominee Director Services (annual)', section: null },
  { fee: 'fee_annual_xbrl', currency: 'currency_fee_annual_xbrl', label: 'XBRL Services', section: null },
  { fee: 'fee_annual_corppass_maintenance', currency: 'currency_fee_annual_corppass_maintenance', label: 'Maintenance of Corppass', section: null },
] as const;
</script>

<template>
  <div class="allot-doc">
    <div class="doc-head">
      <div class="doc-lbl-title">PROPOSAL</div>
      <div class="sg-csp-letterhead">
        <div><CddVarField field-key="csp_name" label="CSP Name" /></div>
        <div><CddVarField field-key="csp_address_line1" label="CSP Address Line 1" /></div>
        <div><CddVarField field-key="csp_address_line2" label="CSP Address Line 2" /></div>
        <div class="sg-csp-meta">
          <CddVarField field-key="csp_phone" label="CSP Phone" />
          <CddVarField field-key="csp_email" label="CSP Email" />
          <CddVarField field-key="csp_website" label="CSP Website" />
        </div>
      </div>
      <div class="doc-company" style="font-size:14px; margin-top:4px">
        Incorporation &amp; Corporate Secretarial Services for
        <CddVarField field-key="proposed_company_name" label="Proposed Company Name" />
      </div>
    </div>

    <p class="doc-p">
      We are pleased to submit our proposal for the incorporation and corporate secretarial services
      for the proposed company set out below. The scope of services and our fee schedule are set out below.
    </p>

    <p class="doc-sec-title">1. Types of Services</p>
    <ul class="sg-bullets">
      <li>Application of new company name</li>
      <li>Incorporation of a Private Limited Company (Pte. Ltd.) with ACRA</li>
      <li>Preparation of pre- and post-incorporation documents (Constitution, Consents, First Board Resolution, Share Certificates, Statutory Registers)</li>
      <li>Corppass setup and maintenance</li>
      <li>Provision of a named Company Secretary / Maintenance of Statutory Registers</li>
      <li>Preparation of AGM documents / XBRL filing services</li>
    </ul>

    <p class="doc-sec-title">2. Our Service Fees</p>
    <table class="cdd-tbl fee-tbl">
      <colgroup>
        <col />
        <col class="fee" />
      </colgroup>
      <thead>
        <tr><th>Types of Services</th><th>Service Fee</th></tr>
      </thead>
      <tbody>
        <template v-for="row in FEE_ROWS" :key="row.fee">
          <tr v-if="row.section">
            <td colspan="2" class="cdd-sec">{{ row.section }}</td>
          </tr>
          <tr>
            <td>{{ row.label }}</td>
            <td class="fee-cell">
              <CddVarField :field-key="row.currency" label="Currency" />
              <CddVarField :field-key="row.fee" label="Fee" />
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <p class="doc-sec-title">3. Acceptance</p>
    <p class="doc-p">
      Acceptance Date:
      <CddVarField field-key="acceptance_date" label="Acceptance Date" />
    </p>

    <p class="doc-sec-title">4. Signatures</p>
    <SgPreSigners :var-key="SG_PRE_SIGNER_KEYS.engagement" />
  </div>
</template>

<style scoped>
.sg-bullets { margin: 0 0 12px; padding-left: 22px; font-size: 12.5px; line-height: 1.55; }
.sg-bullets li { margin-bottom: 4px; }
.fee-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.sg-csp-letterhead {
  margin: 8px 0 12px;
  font-size: 12px;
  line-height: 1.55;
  color: #333;
}
.sg-csp-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin-top: 4px;
}
</style>
